export default __webpack_public_path__ + "static/media/mobileapp.aefcfe17.png";